/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCESS_NUMBER: 'Anzahl der Besuche',
    BLACK_FRIDAY_COMISSION_TITLE: 'Provisionen black friday {0}',
    BLACK_FRIDAY_COMMISSION: 'Black Friday Kommissionen {0}',
    BLACK_FRIDAY_COMMISSION_PREVIOUS: 'Black Friday Kommissionen {0}',
    COMISSION_DESCRIPTION: 'Gesamtwert des aktuellen Monats:',
    COMISSION_LAST_MONTH: 'Homolog',
    COMISSION_LAST_TEN: 'Letzte {0} Tage',
    COMISSION_TITLE: 'Provisionen in {0} Tagen:',
    COMMISSION: 'Provision',
    COMMISSION_COLUMN: 'Provision (€)',
    DAILY: 'Täglich',
    DATE: 'Datum',
    FEMALE: 'Weiblich',
    FIFTY_DAYS: '50 Tage',
    GENDER: 'Geschlecht',
    HITS: 'Besuche in {0} Tagen:',
    HITS_DESCRIPTION: 'Besuche',
    HOMOLOGOUS: 'Homolog',
    HOMOLOGOUS_LAST_YEAR: 'Letztes Jahr',
    MALE: 'Männlich',
    NAME: 'Name',
    NEW_CUSTOMERS: 'Neue Kundenkonten {0} Tage:',
    NEW_CUSTOMERS_ANNIVERSARY: 'Neue Konten Prozis Jubiläum {0}',
    NEW_CUSTOMERS_DETAIL_DESCRIPTION:
      'Neue Konten mit ausstehender Bestellung {0} Tage:',
    NO_SALES: 'Keine Verkäufe',
    ORDER_PENDING_CUSTOMERS: 'Konto ausstehende Bestellung',
    ORDERED_CUSTOMERS: 'Neues Kundenkonto',
    ORDERS: 'Bestellungen der letzten {0} Tage:',
    ORDERS_DESCRIPTION: 'Bezahlte Bestellungen der letzten 6 Monate',
    ORDERS_DETAIL_DESCRIPTION:
      'Bestellungen mit ausstehender Zahlung der letzten {0} Tage:',
    ORDERS_PAY: 'Bezahlte Bestellungen',
    ORDERS_PENDING: 'Ausstehende Bestellungen',
    PERCENTAGE: 'Prozentsatz',
    PRODUCT_CATEGORY: 'Kategorie',
    PRODUCT_COLUMN: 'Produkt',
    QT_COLUMN: 'Menge',
    QUANTITY: 'Menge',
    SALES: 'Verkäufe',
    SALES_DESCRIPTION: 'Aktueller Monat',
    SALES_PRODUCT: 'Verkäufe nach Produktkategorie',
    TEN_DAYS: '10 Tage',
    THIRTEEN_DAYS: '30 Tage',
    TOP_COMMISSION_TITLE: 'Top der lukrativsten Artikel',
    TOP_DESCRIPTION: 'Aktueller Monat',
    TOP_GENDER_DESCRIPTION: 'Letzte {0} Tage',
    TOP_GENDER_TITLE: 'Top-Verkäufe nach Geschlecht',
    TOP_TITLE: 'Top der meistverkauften Artikel',
    TWENTY_DAYS: '20 Tage',
    UPDATED_AT: 'Aktualisiert am {0}',
    VALUE: 'Wert'
  },
  SENTENCE: {
    EMPTY_DESCRIPTION: 'Daten fehlen',
    EMPTY_TITLE: 'Keine Daten'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
